import React from 'react'
import PropTypes from 'prop-types'
import {Button as ButtonUI, Tooltip} from '@material-ui/core'
import {withStyles} from '@material-ui/styles';
import {connect} from 'react-redux'
import clsx from 'clsx';

const style = theme => ({
    icon: {
        marginRight: theme.spacing(1)
    },
    disabled: {
        border: `1px solid ${theme.palette.action.disabled}`,
    },
    transparentBorder: {
        border: `1px solid rgba(255,255,255,0.0)`
    }
})

function Button(
    {
        tooltip,
        hideTooltip = false,
        placement,
        classes,
        Icon,
        children,
        isContrast,
        ...others
    }) {

    const button = (<ButtonUI
        classes={{
            //text: classes.transparentBorder,
            disabled: clsx({
                [classes.disabled]: isContrast,
                [classes.transparentBorder]: !isContrast,
            })
        }}
        {...others}
    >
        {Icon &&
        <Icon className={classes.icon}/>
        }
        {children}
    </ButtonUI>)

    if (hideTooltip || !Boolean(tooltip)) {
        return button
    }

    return (
        <Tooltip title={tooltip} placement={placement}>
			<span>
				{button}
			</span>
        </Tooltip>
    )
}

Button.propTypes = {
    variant: PropTypes.oneOf([ 'text', 'outlined', 'contained']),
    color: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
}

Button.defaultProps = {
    variant: 'contained',
    color: 'primary',
    onClick: () => {
    },
}

export default connect((state) => ({
    isContrast: state.store.contrast,
}), {})(withStyles(style)(Button));
